module.exports = __webpack_public_path__ + "static/media/favicon.3863bd35.ico";